import './lib/jquery'

document.addEventListener('DOMContentLoaded', () => {
  $('#attached_file_filesize').change(function () {
    const MAX_LIMIT_FOR_FILE = 50 * 1024 * 1024
    if (this.files[0].size > MAX_LIMIT_FOR_FILE) {
      $('#attached_file_filesize').val('')
      // eslint-disable-next-line no-alert
      alert('Die Maximalgröße ist auf 50MB beschränkt.')
    }
  })
})
